import { useEffect, useRef } from 'react';
import { trapFocus, announceToScreenReader } from '../utils/accessibility';

export const useAccessibility = () => {
  const trapFocusRef = useRef<(() => void) | null>(null);

  const announce = (message: string) => {
    announceToScreenReader(message);
  };

  const setupFocusTrap = (element: HTMLElement | null) => {
    if (trapFocusRef.current) {
      trapFocusRef.current();
    }
    
    if (element) {
      trapFocusRef.current = trapFocus(element);
    }
  };

  const cleanupFocusTrap = () => {
    if (trapFocusRef.current) {
      trapFocusRef.current();
      trapFocusRef.current = null;
    }
  };

  useEffect(() => {
    return cleanupFocusTrap;
  }, []);

  return {
    announce,
    setupFocusTrap,
    cleanupFocusTrap,
  };
};
